
import { useEffect, useState } from "react";
import { Brain } from "lucide-react";

interface AnalyzingStateProps {
  message?: string;
  altMessages?: string[];
  icon?: React.ReactNode;
}

export const AnalyzingState = ({ 
  message = "Analyzing your profile data...",
  altMessages,
  icon = <Brain className="h-12 w-12 text-emerald-500/80" />
}: AnalyzingStateProps) => {
  const [currentMessage, setCurrentMessage] = useState(message);
  const [dotCount, setDotCount] = useState(0);
  
  useEffect(() => {
    if (!altMessages || altMessages.length === 0) return;
    
    const messageInterval = setInterval(() => {
      setCurrentMessage(prev => {
        const currentIndex = altMessages.indexOf(prev);
        if (currentIndex === -1) return altMessages[0];
        return altMessages[(currentIndex + 1) % altMessages.length];
      });
    }, 3000);
    
    return () => clearInterval(messageInterval);
  }, [altMessages]);
  
  // Add dot animation for loading effect
  useEffect(() => {
    const dotInterval = setInterval(() => {
      setDotCount(prev => (prev + 1) % 4);
    }, 500);
    
    return () => clearInterval(dotInterval);
  }, []);
  
  const loadingDots = '.'.repeat(dotCount);
  
  return (
    <div className="flex flex-col items-center justify-center py-8 space-y-5">
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-emerald-200/30 animate-ping"></div>
        <div className="absolute -inset-4 bg-gradient-to-r from-emerald-200/20 to-sky-200/20 rounded-full animate-pulse blur-xl"></div>
        <div className="relative animate-pulse rounded-full p-4 bg-gradient-to-br from-emerald-50 to-sky-50 border border-emerald-200 shadow-lg">
          {icon}
        </div>
      </div>
      <div className="space-y-2 text-center">
        <p className="text-gray-700 font-medium min-h-6 transition-all duration-500">
          {currentMessage}<span className="inline-block w-8 text-left">{loadingDots}</span>
        </p>
        <p className="text-sm text-gray-500">
          This may take a few seconds...
        </p>
      </div>
    </div>
  );
};
